import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { SHOWS, RESIDENCIES } from "../data";
import { scrollToId } from "./Navbar";

export const Shows = () => {
  return (
    <section
      id="shows"
      data-testid="shows-section"
      className="relative py-24 md:py-40 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-16 gap-6">
          <div>
            <Reveal>
              <p className="text-[#003399] font-bold text-xs uppercase tracking-[0.3em] mb-6">
                Where he plays
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-display text-4xl md:text-6xl uppercase text-[#F2F2F2] leading-none">
                Shows &<br />Residencies
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <button
              data-testid="shows-book-btn"
              onClick={() => scrollToId("contact")}
              className="self-start md:self-auto inline-flex items-center gap-2 px-6 py-3 border border-white/20 text-[#F2F2F2] text-xs uppercase tracking-[0.2em] hover:border-[#003399] hover:text-[#003399] transition-colors duration-300"
            >
              Book a date <ArrowUpRight size={16} />
            </button>
          </Reveal>
        </div>

        {/* Notable events as editorial rows */}
        <div className="border-t border-white/10">
          {SHOWS.map((s, i) => (
            <Reveal key={s.venue} delay={i * 0.05}>
              <div
                data-testid={`show-row-${i}`}
                className="group grid grid-cols-12 items-center gap-4 py-6 border-b border-white/10 hover:bg-[#003399]/10 transition-colors duration-300 px-2 md:px-4"
              >
                <span className="col-span-1 font-display text-xs md:text-sm text-[#F2F2F2]/40">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="col-span-7 md:col-span-6 font-display text-base md:text-2xl uppercase text-[#F2F2F2] group-hover:translate-x-2 transition-transform duration-300">
                  {s.venue}
                </span>
                <span className="col-span-4 md:col-span-3 text-[#F2F2F2]/50 text-xs md:text-sm font-light">
                  {s.place}
                </span>
                <span className="hidden md:block col-span-2 text-right text-[10px] uppercase tracking-[0.2em] text-[#003399]">
                  {s.tag}
                </span>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Residencies chips */}
        <div className="mt-20">
          <Reveal>
            <p className="text-[#F2F2F2]/40 text-xs uppercase tracking-[0.3em] mb-8">
              Residencies · Last 5 Years
            </p>
          </Reveal>
          <div className="flex flex-wrap gap-3">
            {RESIDENCIES.map((r, i) => (
              <Reveal key={r} delay={i * 0.04}>
                <motion.span
                  whileHover={{ scale: 1.04 }}
                  data-testid={`residency-${i}`}
                  className="inline-block px-5 py-3 border border-white/15 text-[#F2F2F2]/80 text-xs md:text-sm hover:border-[#003399] hover:text-[#F2F2F2] transition-colors duration-300 cursor-default"
                >
                  {r}
                </motion.span>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Shows;
